import React, { useState } from 'react';
import { Box, AppBar, Toolbar, Typography, Tabs, Tab, Button } from '@mui/material';
import UploadForm from './components/UploadForm';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import Postcard from './components/BirthdayPostcards';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('authToken'));
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    setIsLoggedIn(false);
  };

  return isLoggedIn ? (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <Box sx={{ 
        width: '20%', 
        bgcolor: '#F5F5F5', 
        boxShadow: 3,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}>
        <Box>
          <AppBar position="static" color="primary">
            <Toolbar>
              <Typography variant="h6" style={{ flexGrow: 1 }}>Contact Manager</Typography>
            </Toolbar>
          </AppBar>
          <Tabs
            orientation="vertical"
            value={tabIndex}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="inherit"
            sx={{ mt: 2 }}
          >
            <Tab label="Dashboard" />
            <Tab label="Upload Form" />
            <Tab label="Postcard" />
          </Tabs>
        </Box>
        <Box sx={{ p: 2 }}>
          <Button 
            color="primary" 
            onClick={handleLogout}
            fullWidth
            variant="outlined"
            sx={{ 
              mt: 'auto',
              mb: 2,
              borderColor: '#002855',
              color: '#002855',
              '&:hover': {
                borderColor: '#FFC72C',
                backgroundColor: '#FFC72C',
                color: '#002855'
              }
            }}
          >
            Logout
          </Button>
        </Box>
      </Box>
      <Box sx={{ flexGrow: 1, p: 3 }}>
        {tabIndex === 0 && <Dashboard />}
        {tabIndex === 1 && <UploadForm />}
        {tabIndex === 2 && <Postcard />}
      </Box>
    </Box>
  ) : (
    <Login onLoginSuccess={handleLoginSuccess} />
  );
}

export default App;
